import type { SmokeballAuthenticator } from "../../services/smokeball-authenticator";
import { useHistory } from "react-router-dom";
import { LogoutPresentational } from "./LogoutPresentational";
import { showLogout } from "../../services/dialog-service";
import { MetricPayload, UNKNOWN_METRICS_VALUE } from "../../models/metric-model";
import { createAuthorisedApiRequest } from "../../helpers/create-authorised-request";
import { fetchWrapper } from "../../helpers/fetch-wrapper";
import { getDiagnostics } from "../../helpers/DiagnosticsHelper";

export interface TProps {
  authenticator: SmokeballAuthenticator;
}

export const LogoutContainer = (props: TProps) => {
  const history = useHistory();

  const logout = async () => {
    // We have to send the metric before we log out otherwise we won't be authorised to call the API.
    await sendMetric();

    await showLogout();
    await props.authenticator.logout();

    history.push("/start");
    location.reload();
  };

  const sendMetric = async () => {
    const metricName = "outlook_addin_logout";

    try {
      const diagnostics = getDiagnostics();

      const metricPayload: MetricPayload = {
        Metric: {
          Name: metricName,
          Timestamp: new Date().toISOString(), // Current UTC time
          Dimensions: {
            Platform: diagnostics?.platform || UNKNOWN_METRICS_VALUE,
            Version: diagnostics?.version || UNKNOWN_METRICS_VALUE,
            HostName: diagnostics?.hostName || UNKNOWN_METRICS_VALUE,
            HostVersion: diagnostics?.hostVersion || UNKNOWN_METRICS_VALUE,
            Product: "",
          },
        },
      };

      const { url, requestInit } = await createAuthorisedApiRequest("AddMetricUrl", metricPayload);
      const result = await fetchWrapper(url, requestInit);

      if (result.err) {
        console.error(`Add metric call returned an error when saving ${metricName} metric: `, result.err);
      }
    } catch (error) {
      console.error(`Error occurred when saving ${metricName} metric: `, error);
    }
  };

  return <LogoutPresentational authenticator={props.authenticator} logout={logout} />;
};
